import React from 'react';
import {
  List,
  ContentWrapper,
  StyledButton,
  StyledCaptions,
  StyledTitle,
  WrappedLineShortBody,
} from 'containers/MRhDashboard/DeclareSinistre/Styles';
import { sanlamBlue } from 'Material-UI/colors';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import messages from 'containers/MRhDashboard/messages';
import { uppercase } from 'utils/string';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { Grid } from '@material-ui/core';

const DeclareSinistre = (props: {
  intl: IntlShape;
  openModalServicesMrh: Function;
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <React.Fragment>
      <StyledTitle>
        {translate(messages.declareSinistreTitle, props)}
      </StyledTitle>
      <ContentWrapper reverse={reverse}>
        <Grid container justify="flex-start">
          <Grid item>
            <WrappedLineShortBody weight="500" color={sanlamBlue}>
              {translate(messages.possibilitiesDeclareSinistre, props)}
            </WrappedLineShortBody>
            <List>
              <li>
                <StyledCaptions color="#575E71" weight="400">
                  {translate(messages.declareSinistrePhone, props)}
                </StyledCaptions>
              </li>
              <li>
                <StyledCaptions color="#575E71" weight="400">
                  {translate(messages.declareSinistreAgent, props)}
                </StyledCaptions>
              </li>
            </List>
          </Grid>
          <Grid item>
            <GaClickHOC
              category={EVENT_CATEGORIES.MRH_ACCUEIL}
              label="Comment déclarer un sinistre?_En savoir plus"
            >
              <StyledButton
                variant="outlined"
                size="small"
                data-testid="find-out-more"
                onClick={() => props.openModalServicesMrh()}
              >
                {uppercase(translate(messages.VoirDetail, props))}
              </StyledButton>
            </GaClickHOC>
          </Grid>
        </Grid>
      </ContentWrapper>
    </React.Fragment>
  );
};

export default injectIntl(DeclareSinistre);
